/* Copyright Information: Created by BuyGroup */
import Api from "../Api";

export const getOrderList = (data) => {
  return Api.post("orders", data).then((res) => res.data);
};

export const orderStatus = (data) => {
  return Api.put("order-status/update", data).then((res) => res.data);
};

export const supplierOrderList = () => {
  return Api.get("orderBySupplierId").then((res) => res.data);
};

export const placeAmazonOrder = (data) => {
  return Api.post("order/place-amazon-order", data).then((res) => res.data);
};

export const downloadInvoice = (orderLineId) => {
  return Api.get(`order/download-invoice?customerOrderLineId=${orderLineId}`, { responseType: "text" }).then((res) => res.data);
};

/* Copyright Information: Created by BuyGroup */
